import TextFade from "../../components/CustomTexts/TextFade";
//import CallToActionSection from "../../components/Others/CallToActionSection";
import heroImage from "../../assets/wactcsr/wact10.jpg";
import sandDredgingImage from "../../assets/wactcsr/wact.jpg";
import missionImage from "../../assets/wactcsr/wact10.jpg";
import TextEffect from "../../components/CustomTexts/TextEffect";
import bgIMG from "../../assets/tan2.jpg";
import trainingImg from "../../assets/wactcsr/wact6.jpg";
import chysonImg from "../../assets/wactcsr/wact4.jpg";
import farmImg from "../../assets/wactcsr/wact8.jpg";
import consultancyImg from "../../assets/wactcsr/wactcsr4.jpg";
import consultancy2Img from "../../assets/wactcsr/wact2.jpg";
import consultancy3Img from "../../assets/wactcsr/wact5.jpg";
import consultancy4Img from "../../assets/wactcsr/wact7.jpg";
import consultancy5Img from "../../assets/wactcsr/wact8.jpg";
import consultancy6Img from "../../assets/wactcsr/wactcsr1.jpg";
import consultancy7Img from "../../assets/wactcsr/wactcsr2.jpg";
import consultancy8Img from "../../assets/wactcsr/wactcsr6.jpg";
import consultancy9Img from "../../assets/wactcsr/wactcsr3.jpg";
import consultancy10Img from "../../assets/wactcsr/wactcsr4.jpg";
import consultancy11Img from "../../assets/wactcsr/wactcsr5.jpg";
import consultancy12Img from "../../assets/wactcsr/wactcsr8.jpg";
import consultancy13Img from "../../assets/wactcsr/wactcsr7.jpg";
import consultancy14Img from "../../assets/wactcsr/wact.jpg";
import consultancy15Img from "../../assets/wactcsr/wact1.jpg";
import consultancy16Img from "../../assets/wact.jpg";
import consultancy25Img from "../../assets/wactcsr/wact2.jpg";
//import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useState } from "react";

const ImageModal = ({ image, caption, onClose }: { image: string, caption: string, onClose: () => void }) => (
  <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full overflow-hidden relative">
      <img src={image} alt={caption} className="w-full max-h-[80vh] object-contain" />
      <p className="text-center text-lg font-semibold text-dark py-4">{caption}</p>
      <button
        onClick={onClose}
        className="absolute top-2 right-2 text-white bg-black rounded-full p-2 hover:bg-gray-700"
      >
        ✕
      </button>
    </div>
  </div>
);

const WactCsrTraining = () => {
  const [modal, setModal] = useState<{ img: string; caption: string } | null>(null);
  const [activeTab, setActiveTab] = useState("participation");

  const trainingGallery = [
    { img: consultancy7Img, caption: "Hands-On Workshop" },
    { img: trainingImg, caption: "Personalized Mentorship" },
    { img: farmImg, caption: "Empowering Farmers" },
    { img: sandDredgingImage, caption: "Field Experience" },
    { img: consultancyImg, caption: "Consultancy Session" },
    { img: consultancy2Img, caption: "Knowledge Sharing" },
    { img: consultancy3Img, caption: "Community Engagement" },
    { img: consultancy4Img, caption: "Sustainable Practices" },
    { img: consultancy5Img, caption: "Innovative Solutions" },
    { img: consultancy6Img, caption: "Agricultural Training" },
    { img: consultancy8Img, caption: "Empowering Youth" },
    { img: consultancy9Img, caption: "Hands-On Learning" },
    { img: consultancy10Img, caption: "Field Demonstration" },
    { img: consultancy11Img, caption: "Practical Skills" },
    { img: consultancy12Img, caption: "Community Impact" },
    { img: consultancy13Img, caption: "Agribusiness Development" },
    { img: consultancy14Img, caption: "Sustainable Agriculture" },
    { img: consultancy15Img, caption: "Training Session" },
    { img: consultancy16Img, caption: "Empowering Farmers" },
    { img: consultancy25Img, caption: "Value-Addition Workshops" },
    { img: chysonImg, caption: "Market Navigation" },
    { img: missionImage, caption: "Agricultural Innovation" }
  ];

  const tabContent: Record<string, JSX.Element> = {
    participation: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Empowerment training CSR Project
                    </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
West Africa Container Terminal (WACT)  and APMT are the operators of Onne Deep Sea Port located at Onne Eleme Local Government Area of Rivers State and bounded by Ogu in Ogu/Bolo Local Government Area.
             </p>
             <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
The company has a tradition of using their Corporate Social Responsibility Projects to intervene in critical areas of her host communities.
              </p>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
In October 2024, WACT engaged Simdozi International Limited to implement a food and nutrition security strategic project to improve the health and nutrition of these communities as well as improve their economy by developing enterprises based on Orange Fleshed Sweet Potato Value Chain Development.
          </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy9Img} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    rural: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Project Target & Beneficiaries
                </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
The Project was first targeted at 500 beneficiaries in 2024 but later increased to 1000 in 2025.
         </p>
         <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
The beneficiaries were trained on the whole gamut of OFSP Value Chain from health, social and economic benefits to production, processing, packaging and marketing. 
</p>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
The beneficiaries were trained on the whole gamut of OFSP Value Chain from health, social and economic benefits to production, processing, packaging and marketing. 
          </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy2Img} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    health: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Health, Productivity & Economic empowerment
                </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          The Shabu training embraced a rural impact approach, focusing on sustainable change through technology. Participants learned to cultivate orange-fleshed sweet potato (OFSP) using eco-friendly methods, enhancing food security and nutrition in their communities. The training emphasized practical skills, enabling farmers to adapt to local conditions and market demands.
         </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy4Img} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    development: (
      <div className="flex flex-col md:flex-row-reverse items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
            Value-Addition Workshops
          </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          The training included hands-on workshops on post-harvest techniques, preservation methods, and value addition. Participants learned to process OFSP into flour, chips, and other products, enhancing marketability and shelf life.
          </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy13Img} alt="Mentorship" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    knowledge: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
            Agricultural Collaboration & Market Navigation
          </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          Understand pricing, grading standards, packaging, and building relationships with buyers and retailers. West Africa Container Terminal (WACT)  and APMT are the operators of Onne Deep Sea Port located at Onne Eleme Local Government Area of Rivers State and bounded by Ogu in Ogu/Bolo Local Government Area.
          </p>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
            The company has a tradition of using their Corporate Social Responsibility Projects to intervene in critical areas of her host communities.
            </p>
        </div>
        <div className="md:w-1/2">
          <img src={chysonImg} alt="Knowledge Sharing" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    )
  };

  return (
    <div className="about-container">
      {/* Hero Section */}
      <div
        className="relative h-[60vh] flex items-center justify-center text-white bg-cover bg-center z-0"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-black opacity-50 z-0" />
        <div className="z-10">
          <TextEffect text="WACT Empowerment Training " className="hero-title" />
        </div>
      </div>

      {/* Tabbed Pane Section */}
      <div className="px-4 sm:px-[6%] mt-20 mb-24 gap-6">
                <div className="flex flex-wrap justify-center mb-8 space-x-4">
          <button
            onClick={() => setActiveTab("participation")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "participation" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
        Empowerment training CSR Project             </button>

          <button
            onClick={() => setActiveTab("rural")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "rural" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
            Project Target & Beneficiaries
                 </button>
               
          <button
            onClick={() => setActiveTab("development")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "development" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
        Value-Addition Workshops          </button>
          <button
            onClick={() => setActiveTab("knowledge")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "knowledge" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
            Agricultural Collaboration & Market Navigation          </button>
        </div>

        <div className="transition-all duration-500">{tabContent[activeTab]}</div>
      </div>


      {/* Overview Section */}
      <div className="relative">
        <div
          className="relative bg-green-500 text-white px-4 sm:px-[5%] py-20 bg-cover bg-center z-0"
          style={{ backgroundImage: `url(${bgIMG})` }}
        >
          <div className="absolute inset-0 bg-green-650 opacity-80 z-0" />
          <div className="relative z-10 flex md:flex-row flex-col justify-between items-center gap-16">
            <div className="md:w-[40%] w-full flex justify-center">
              <img src={missionImage} alt="Empowering Farmers" className="w-[80%] max-w-[450px]" />
            </div>
            <div className="md:w-[60%] w-full space-y-4">
              <TextFade animation="fade-down">
                <h1 className="text-[30px] md:text-[40px] font-bold text-white mb-4 leading-tight">
                  <TextEffect text4="WEST AFRICA CONTAINER TERMINAL (WACT) EMPOWERMENT " />
                  <TextEffect text4=" TRAINING CSR PROJECT, ONNE" />
                </h1>
              </TextFade>
              <p className="text-white text-[17px] md:text-[20px] leading-relaxed">
West Africa Container Terminal (WACT)  and APMT are the operators of Onne Deep Sea Port located at Onne Eleme Local Government Area of Rivers State and bounded by Ogu in Ogu/Bolo Local Government Area.
              </p>
              <p className="text-white text-[17px] md:text-[20px] leading-relaxed">
At the end of the training in production, beneficiaries are empowered with the planting materials to set up their vines. After three months of planting, harvest is done and further training on processing, packaging and marketing is carried out. The impact of the training is already obvious as the first set of beneficiaries are already using the OFSP to improve the nutrition of their families and communities as well as making money from their OFSP farms or pastry products.
</p>
            </div>
          </div>
        </div>
      </div>
      {/* Gallery Section */}
      <div className="px-4 sm:px-[5%] mt-24 mb-20">
        <TextFade animation="fade-up">
          <h1 className="text-center text-[24px] md:text-[30px] font-bold text-dark mb-8">
            <TextEffect part4="West Africa Container Terminal (WACT) Gallery" />
          </h1>
        </TextFade>

        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
          navigation
          autoplay={{ delay: 3000 }}
          loop
          modules={[Navigation, Autoplay]}
        >
          {trainingGallery.map(({ img, caption }, index) => (
            <SwiperSlide key={index}>
              <div
                className="relative w-full h-[260px] sm:h-[300px] rounded-xl overflow-hidden group cursor-pointer"
                onClick={() => setModal({ img, caption })}
              >
                <img src={img} alt={caption} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300">
                  <p className="text-white text-lg font-bold">{caption}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {modal && <ImageModal image={modal.img} caption={modal.caption} onClose={() => setModal(null)} />}
    </div>
  );
};

export default WactCsrTraining;
